"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _calculatePosition = _interopRequireDefault(require("./calculatePosition"));

var _classnames = _interopRequireDefault(require("classnames"));

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _getContainer = _interopRequireDefault(require("react-overlays/lib/utils/getContainer"));

var _ownerDocument = _interopRequireDefault(require("react-overlays/lib/utils/ownerDocument"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Position =
/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
(0, _convertUnsafeMethod["default"])(_class = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Position, _React$Component);

  function Position(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Position);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Position).call(this, props, context));
    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null,
      placement: _this.props.placement
    };
    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  (0, _createClass2["default"])(Position, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updatePosition(this.getTarget());
      window.addEventListener('resize', this.maybeUpdatePosition, false);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      this._needsFlush = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this._needsFlush) {
        this._needsFlush = false;
        this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.maybeUpdatePosition, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "className"]);
      var _this$state = this.state,
          positionLeft = _this$state.positionLeft,
          positionTop = _this$state.positionTop,
          maxHeight = _this$state.maxHeight,
          arrowOffsetLeft = _this$state.arrowOffsetLeft,
          arrowOffsetTop = _this$state.arrowOffsetTop,
          placement = _this$state.placement;
      delete props.target;

      var child = _react["default"].Children.only(children);

      return (0, _react.cloneElement)(child, _objectSpread({}, (0, _filterDOMProps["default"])(props), {
        placement: placement,
        className: (0, _classnames["default"])(className, child.props.className),
        arrowStyle: {
          left: arrowOffsetLeft,
          top: arrowOffsetTop
        },
        style: _objectSpread({}, child.props.style, {
          position: 'absolute',
          zIndex: 100000,
          // should match the z-index in ModalTrigger
          left: positionLeft,
          top: positionTop,
          maxHeight: maxHeight
        })
      }));
    }
  }, {
    key: "getTarget",
    value: function getTarget() {
      var target = this.props.target;
      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom["default"].findDOMNode(targetElement) || null;
    }
  }, {
    key: "maybeUpdatePosition",
    value: function maybeUpdatePosition(placementChanged) {
      var target = this.getTarget();

      if (!this.props.shouldUpdatePosition && target === this._lastTarget && !placementChanged) {
        return;
      }

      this.updatePosition(target);
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(target) {
      var _this$props2 = this.props,
          placement = _this$props2.placement,
          containerPadding = _this$props2.containerPadding,
          offset = _this$props2.offset,
          crossOffset = _this$props2.crossOffset,
          flip = _this$props2.flip,
          boundariesElement = _this$props2.boundariesElement;
      this._lastTarget = target;

      if (!target) {
        this.setState({
          positionLeft: 0,
          positionTop: 0,
          arrowOffsetLeft: null,
          arrowOffsetTop: null
        });
        return;
      }

      var overlay = _reactDom["default"].findDOMNode(this);

      var container = (0, _getContainer["default"])(this.props.container, (0, _ownerDocument["default"])(this).body);
      this.setState((0, _calculatePosition["default"])(placement, overlay, target, container, containerPadding, flip, boundariesElement, offset, crossOffset));
    }
  }]);
  return Position;
}(_react["default"].Component), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  containerPadding: 10,
  offset: 0,
  crossOffset: 0
}), _temp)) || _class) || _class;

exports["default"] = Position;